<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('redeem.editTitle') }}</h2>
            <p class="text-muted small mb-0">{{ $t('redeem.editSub') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <form class="forms-sample" method="post" @submit.prevent="submitForm">
            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="nameInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('redeem.itemName') }}</label>
                <input
                  id="nameInput"
                  type="text"
                  class="form-control"
                  v-model="ruleStore.name"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Voucher Belanja Tokopedia Rp 100.000' : 'e.g. Shopping Voucher / Gift Card $10'"
                  required
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="goldInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('redeem.costGold') }}</label>
                <div class="input-group">
                  <input
                    id="goldInput"
                    type="number"
                    class="form-control"
                    v-model="ruleStore.gold"
                    min="1"
                    placeholder="100"
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text bg-dark border-secondary text-warning font-weight-bold">
                      <i class="mdi mdi-circle-multiple mr-1"></i> Gold
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button type="button" @click="back" class="btn btn-outline-secondary px-4 py-2 mr-2" :disabled="loading">
                {{ $t('common.back') }}
              </button>
              <button type="submit" class="btn btn-primary px-4 py-2 font-weight-bold" :disabled="loading">
                <span class="spinner-border spinner-border-sm mr-1" v-if="loading" role="status"></span>
                <i class="mdi mdi-check-all mr-1" v-else></i>
                {{ $t('common.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailRedeem, updateRedeem } from "../../services/redeemService";
import Swal from 'sweetalert2';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    ruleStore: {
      name: '',
      gold: 0,
    },
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    async submitForm() {
      try {
        this.loading = true;
        await updateRedeem(this.id, this.ruleStore);
        Swal.fire({
          icon: "success",
          title: this.$t('common.success'),
          text: this.$t('redeem.savedSuccess'),
          confirmButtonColor: "#3b82f6",
        });

        this.$router.push('/redeem');
      } catch (error) {
        console.error(error);
        const errMsg = error.response?.data?.message || (this.$currentLocale === 'id' ? 'Gagal menyimpan perubahan item hadiah' : 'Failed to update reward item');
        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: errMsg,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchRedeem() {
      try {
        const response = await getDetailRedeem(this.id);
        this.ruleStore.name = response.data.name || '';
        this.ruleStore.gold = response.data.gold || 0;
      } catch (err) {
        console.error('Error fetching redeem detail:', err);
      }
    },
  },
  mounted() {
    this.fetchRedeem();
  }
};
</script>
